/* eslint-disable */
import React from 'react';
import classNames from 'classnames';

/**
 * Style.
 */
import './button.scss';

const Button = ({
  children, orange, blue, red, transparentBlue, active, fullWidth, type, ...rest
}) => (
    <button
      type={type ? type : 'button'}
      {...rest}
      className={classNames('button', {
        active,
        orange,
        blue,
        red,
        'full-width': fullWidth,
        'transparent-blue': transparentBlue,
      })}
    >
      {children}
    </button>);

export default Button;
/* eslint-enable */
